export function DEFAULT_VALIDATION(value, msg) {
  if (!value) {
    return {
      error: true,
      message: `Please enter ${msg}`
    };
  }
  if (value.length < 3) {
    return {
      error: true,
      message: "Min length 3"
    };
  } else {
    return {
      error: false,
      message: ""
    };
  }
}

export function ONLY_CHARS(value, msg) {
  if (!value) {
    return {
      error: true,
      message: `Please enter ${msg}`
    };
  }
  const regex = /^[a-zA-Z ]*$/gi;
  const isValid = regex.test(value);
  if (value.length < 3) {
    return {
      error: true,
      message: "Min length 3"
    };
  } else {
    return {
      error: !isValid,
      message: !isValid && "Only characters are allowed"
    };
  }
}

export function VALIDATE_USER_ID(value, msg) {
  if (!value) {
    return {
      error: true,
      message: `Please enter ${msg}`
    };
  }
  // const regex = /^[a-zA-z0-9_.&]*$/gi;
  const regex = /^[A-Za-z0-9](?!.*@.*@)(?!.*[^A-Za-z0-9@._-])(?!.*[@._-]{2,})(?!.*[._-]$)[A-Za-z0-9@._-]*[A-Za-z0-9]$/;
  // const regex = /^[A-Za-z0-9](?!.*@.*@)(?!.*[^A-Za-z0-9@._&-])(?!.*[@._&-]{2,})(?!.*[._&-]$)[A-Za-z0-9@._&-]*[A-Za-z0-9]$/;

  const isValid = regex.test(value);
  console.log("isValid", isValid);

  if (value.length < 3) {
    return {
      error: true,
      message: "Min length 3"
    };
  }
  return {
    error: !isValid,
    message: !isValid && "Invalid User ID"
  };
}

export function ONLY_CHARS_NUM(value, msg) {
  if (!value) {
    return {
      error: true,
      message: `Please enter ${msg}`
    };
  }
  const regex = /^[0-9a-zA-Z]+$/gi;
  const isValid = regex.test(value);
  if (value.length < 3) {
    return {
      error: true,
      message: "Min length 3"
    };
  } else {
    return {
      error: !isValid,
      message: !isValid && "Only characters & numbers are allowed"
    };
  }
}

// export function PHONE_VALIDATE(contactType, fieldName, value) {
//   //console.log("contactType", contactType);
//   if (!value && contactType === "mobile") {
//     return {
//       error: true,
//       message: "Please enter Mobile Number"
//     };
//   } else if (!value && contactType === "landline") {
//     console.log("from else if");
//     return {
//       error: true,
//       message: "Please enter LandLine Number"
//     };
//   }
//   if (contactType === "mobile") {
//     const regex = /^[5-9]\d{9}$/gi;
//     const isValid = regex.test(value);
//     return {
//       error: !isValid,
//       message: !isValid && "Please enter Valid Mobile Number"
//     };
//   } else if (contactType === "landlineNumber") {
//     const regex = /^\d{3}-\d{4}-\d{4}$/;
//     const isValid = regex.test(value);
//     return {
//       error: !isValid,
//       message: !isValid && "Please enter Valid Landline Number"
//     };
//   }
// }

export function PHONE_VALIDATE(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter Mobile Number"
    };
  }
  const regex = /^[5-9]\d{9}$/gi;
  const isValid = regex.test(value);
  return {
    error: !isValid,
    message: !isValid && "Invalid mobile number"
  };
}

export function PHONE_VALIDATE_CMS(contactType, fieldName, value) {
  console.log("Ashish13" + contactType + value);
  // if (!value) {
  //   return {
  //     error: true,
  //     message: "Please enter Contact Number"
  //   };
  // }
  if (contactType === "mobile") {
    if (!value) {
      return {
        error: true,
        message: "Please enter Mobile Number"
      };
    } else {
      const regex = /^[5-9]\d{9}$/gi;
      const isValid = regex.test(value);
      return {
        error: !isValid,
        message: !isValid && "Please enter Valid Mobile Number"
      };
    }
  } else if (contactType === "landline") {
    if (!value) {
      return {
        error: true,
        message: "Please enter Landline Number"
      };
    } else {
      const regex = /^\d{3}-\d{4}-\d{4}$/;
      const isValid = regex.test(value);
      return {
        error: !isValid,
        message: !isValid && "Please enter Valid Landline Number"
      };
    }
  } else {
    if (!value) {
      return {
        error: true,
        message: "Please enter Mobile Number"
      };
    } else {
      const regex = /^\d{3}-\d{4}-\d{4}$/;
      const isValid = regex.test(value);
      return {
        error: !isValid,
        message: !isValid && "Please enter Valid Mobile Number"
      };
    }
  }
}

export function LANDLINENUMBER_VALIDATE(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter Valid Landline Number"
    };
  }
  const regex = /^\d{3}-\d{4}-\d{4}$/;
  const isValid = regex.test(value);
  return {
    error: !isValid,
    message: !isValid && "Please enter Valid Landline Number"
  };
}

// export function LANDLINENUMBER_VALIDATE(landlineNumber) {
//   // Assuming landline numbers should have the format "XXX-XXXXXXX"
//   const landlineRegex = /^\d{3}-\d{7}$/;

//   return landlineRegex.test(landlineNumber);
// }

// // Example usage
// const isValidLandline = LANDLINENUMBER_VALIDATE("123-4567890");

// if (isValidLandline) {
//   console.log("The landline number is valid.");
// } else {
//   console.log("Invalid landline number format.");
// }

export function MIN_MAX_LENGTH(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter this Field"
    };
  }
  const isTrue = value.length >= 3 && value.length <= 50;
  return {
    error: !isTrue,
    message: !isTrue && "Min length 3 digit & Max length 50 digit"
  };
}

export function OTP_LENGTH(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter OTP"
    };
  }
  const isTrue = value.toString().length === 4;
  return {
    error: !isTrue,
    message: !isTrue && "Min & Max length 4 digit"
  };
}

export function EMAIL_VALIDATE(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter Email Address"
    };
  }
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // const regex = /^(.+)@(.+)\\.(.+)$/;
  const isValid = regex.test(value);
  const isTrue = value.length > 100;

  if (isTrue) {
    return {
      error: isTrue,
      message: "Max Length is 100"
    };
  }

  return {
    error: !isValid,
    message: !isValid && "Please enter valid Email Address"
  };
}

export function EMAIL_VALIDATE_USERID(value) {
  if (!value) {
    return {
      error: true,
      message: "Please specify username or email."
    };
  }
  const isTrue = value.length > 100;

  if (isTrue) {
    return {
      error: isTrue,
      message: "Max Length is 100"
    };
  }

  return {
    error: false,
    message: ""
  };
}

export function PASSWORD_VALIDATE(value, pwd, type) {
  if (!value) {
    return {
      error: true,
      message: "Please enter password"
    };
  }
  const regex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%])(?=\S+$).{8,20})$/;
  const isValid = regex.test(value);
  const uperlimit = value.length > 20;
  const lowerlimit = value.length < 8;

  if (pwd && pwd !== value) {
    return {
      error: true,
      message: "Passwords do not match."
    };
  } else if (uperlimit) {
    return {
      error: uperlimit,
      message: "Max length is 30 characters"
    };
  } else if (lowerlimit) {
    return {
      error: lowerlimit,
      message: "Minimum length is 8 characters"
    };
  } else {
    return {
      error: !isValid,
      message:
        (!isValid &&
          "Use 8 or more characters with at least one upper case letter, one lower case letter, one number and atleast one special character from ( @ # $ % ) and no space is allowed. E.g. Test@123") ||
        ""
    };
  }
}

// only user can type numbers
export function onlyNumbers(value) {
  const replaceZero = value.replace(/^0/, "");
  return replaceZero && replaceZero.replace(/[^0-9]/gi, "");
}

// only for cost
export function onlyForCostNumbers(value) {
  if (value) {
    const replaceZero = value.replace(/(^|\\)/, "");
    const extractMatchedValue = replaceZero.match(
      /^(\d{0,6}(?:\.{1}\d{0,2})?).*/
    );
    return (extractMatchedValue && extractMatchedValue[1]) || "";
  }
}

// validate percentage
export function validatePercentage(
  value,
  include100 = false,
  isMandatory = false,
  key = ""
) {
  if (!value) {
    return {
      error: isMandatory,
      message: (isMandatory && "Please enter percentage") || ""
    };
  }

  let regex = /^(\d{0,2}(\.\d{1,10})?)$/gi;
  let message = "100%.";
  if (include100) {
    regex = /^(100(\.0{1,10})?|[0-9]{0,2}(\.\d{1,10})?)$/gi;
    message = "or equal to 100%.";
  }
  const isValid = regex.test(value);
  if (key === "percentage") {
    return {
      error: !isValid,
      message:
        !isValid &&
        "Must be less than 100% or mark project status as Completed."
    };
  }
  return {
    error: !isValid,
    message: (!isValid && `Must be less than ${message}`) || ""
  };
}

// For positive numbers and decimals
export function numberWithDecimal(value) {
  if (value) {
    const regex = /^(0|[1-9]\d*|([0-9]*\.)\d*)$/;
    let newValue = "";
    const checkValue = regex.test(value);
    if (!!checkValue) {
      newValue = value;
    } else {
      newValue = value.slice(0, -1);
    }
    return newValue;
  }
}

// Zip Code Validation
export function ZIP_CODE_VALIDATION(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter Zip Code"
    };
  }
  const isValid = /[0-9]{6}/gi.test(value);
  return {
    error: !isValid,
    message: (!isValid && "Invalid Zip Code") || ""
  };
}

export const VALIDATE_URLS = value => {
  if (!value) {
    return {
      error: true,
      message: "Please enter URL"
    };
  }
  const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/gi;
  return urlRegex.test(value)
    ? { error: false, message: "" }
    : { error: true, message: "Invalid URL" };
};

export function NAME_VALIDATE(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter Name"
    };
  }
  let valueExceeded = value.length > 30;
  if (valueExceeded) {
    return {
      error: valueExceeded,
      message: valueExceeded && "Max length allowed is 30 characters"
    };
  }
  /* const regex = /^[a-zA-Z ]+$/;
  const isValid = regex.test(value);
  return {
    error: !isValid,
    message: !isValid && "Please enter Member Name"
  };*/
  return {
    error: false,
    message: ""
  };
}

export function CMS_NAME_VALIDATE(value) {
  if (!value) {
    return {
      error: true,
      message: "Please enter Name"
    };
  }
  let valueExceeded = value.length > 30;
  if (valueExceeded) {
    return {
      error: valueExceeded,
      message: valueExceeded && "Max length allowed is 30 characters"
    };
  }
  return {
    error: false,
    message: ""
  };
}

export function DESIGNATION_VALIDATE(value) {
  if (value == "") {
    return {
      error: true,
      message: "Please enter Designation"
    };
  }
}

export function ADDRESS_VALIDATE(value) {
  let valueExceeded = value.length > 50;
  if (valueExceeded) {
    return {
      error: valueExceeded,
      message: valueExceeded && "Max length allowed is 50 characters"
    };
  }
  if (!value) {
    return {
      error: true,
      message: "Please enter Address"
    };
  }
  return {
    error: false,
    message: ""
  };
  // const regex = /^[a-zA-Z0-9\s,.-]+$/;
  // const isValid = regex.test(value);
  // return {
  //   error: !isValid,
  //   message: !isValid && "Please enter Valid Address"
  // }
}

export function TITLE_VALIDATE(value) {
  let valueExceeded = value.length > 150;
  if (!value) {
    return {
      error: true,
      message: "This field is required"
    };
  } else if (valueExceeded) {
    return {
      error: valueExceeded,
      message: valueExceeded && "Max length is 150 characters"
    };
  } else {
    return {
      error: false,
      message: ""
    };
  }
}

export function IMAGE_VALIDATE(value) {
  if (!value) {
    return {
      error: true,
      message: "This field is required"
    };
  } else {
    return {
      error: false,
      message: ""
    };
  }
}

export function DESCRIPTION_VALIDATE(value) {
  let valueExceeded = value.length > 400;
  if (!value) {
    return {
      error: true,
      message: "This field is required"
    };
  } else if (valueExceeded) {
    return {
      error: valueExceeded,
      message: valueExceeded && "Max length is 150 characters"
    };
  } else {
    return {
      error: false,
      message: ""
    };
  }
}

export function DATE_VALIDATE(dateString) {
  // Check if the string is in the format YYYY-MM-DD
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  if (!dateString) {
    //!dateRegex.test(dateString)
    // dateString = dateString.toISOString().split('T')[0];
    return {
      error: true,
      message: "This field is required"
    };
  } else {
    return {
      error: false,
      message: ""
    };
  }
}

export const PAGEURL_VALIDATE = value => {
  if (!value) {
    return {
      error: true,
      message: ""
    };
  }
};

export function USER_EXIST(value, userId, msg) {
  if (!userId) {
    return {
      error: true,
      message: `Please Enter ${msg}`
    };
  }
  if (value) {
    return {
      error: true,
      message: `${msg} already exists.`
    };
  } else {
    return {
      error: false,
      message: `${msg} is available`
    };
  }
}
